import App from './app';

import { copyright, noTabnabbing } from './partials/utilities';
import nav from './partials/nav';
import accordion from './partials/accordion';
import content from "./partials/content";
import search from './partials/search';


/**
 * Execute all imported JavaScript components.
 *
 * @export
 */
export default function() {
    copyright();
    noTabnabbing();
    nav();
    accordion();
    content();
    search();
}


// WEBPACK FOOTER //
// ./src/js/index.js